module.exports = __webpack_public_path__ + "img/PRCA2_Treg.e4a29c85.png";